import * as yup from 'yup'

export const adminSetMasterAdminSchema = yup
  .object({
    masterAdminUserId: yup.string().required(),
  })
  .required()
